function gridSwatchesSlider() {
  var swiper = new Swiper(".mcard-swatches-slider", {
    spaceBetween: 0,
    slidesPerView: "auto",
    watchOverflow: true,
    autoplay: false,
    navigation: {
      nextEl: ".mcard-swiper-button-next",
      prevEl: ".mcard-swiper-button-prev",
    },
  });
}

document.addEventListener('DOMContentLoaded', () => {
    gridSwatchesSlider();
  });
